import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09cc94eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "window"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { id: "divInputArea" }
const _hoisted_4 = { style: {"width":"68% !important"} }
const _hoisted_5 = { id: "tblUserID" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode("User ID "),
  /*#__PURE__*/_createElementVNode("span", { id: "userid_importance" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { id: "userid_bold" }, ":")
], -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_8 = {
  colspan: "2",
  class: "errmessage"
}
const _hoisted_9 = {
  class: "loginManual-link",
  style: {"width":"32% !important"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle" }, null, -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Alternative Login Manual ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { id: "divCommonTbl" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"divCommonTblHeader\" data-v-09cc94eb><table id=\"tblLoginAdmin\" data-v-09cc94eb><thead data-v-09cc94eb><tr data-v-09cc94eb><th class=\"w-8\" data-v-09cc94eb>User ID</th><th class=\"w-20\" data-v-09cc94eb>User Name</th><th class=\"w-8\" data-v-09cc94eb>Create User</th><th class=\"w-18\" data-v-09cc94eb>Create Date</th><th class=\"w-8\" data-v-09cc94eb>Update User</th><th class=\"w-18\" data-v-09cc94eb>Update Date</th><th class=\"w-8\" data-v-09cc94eb>Status</th><th class=\"w-12\" data-v-09cc94eb></th></tr></thead></table></div>", 1)
const _hoisted_15 = { id: "divLoginAdminHistoryBody" }
const _hoisted_16 = {
  id: "tblLoginAdmin",
  class: "w-100"
}
const _hoisted_17 = { id: "tblLoginAdminHistoryBody" }
const _hoisted_18 = { class: "w-8" }
const _hoisted_19 = { class: "w-20" }
const _hoisted_20 = { class: "w-8" }
const _hoisted_21 = { class: "w-18" }
const _hoisted_22 = { class: "w-8" }
const _hoisted_23 = { class: "w-18" }
const _hoisted_24 = { class: "w-8" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("active")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("deleted")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("reactivated")
const _hoisted_28 = { class: "w-12" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  id: "noDataLogin"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, "No Data", -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  class: "modal fade",
  id: "loginadminModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_35 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  id: "confirmModalBody"
}
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Delete Status")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Activate Status")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_42 = {
  class: "modal-body",
  id: "confirm-modal-body"
}
const _hoisted_43 = { id: "modal_header" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Are you sure to delete?")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Are you sure to activate?")
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "modalCancel",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Activate")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "8",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputUserId) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.inputUserId]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btnLoginAdmin btnLoginAdmin-Add",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.checkLoginAdminList()))
                }, "Add")
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", _hoisted_8, _toDisplayString($setup.errormessage), 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openLoginManualPDF()))
        }, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("tbody", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loginAdminList[0], (loginAdminData, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(loginAdminData.userId_id), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(loginAdminData.givenName) + " " + _toDisplayString(loginAdminData.familyName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(loginAdminData.createUser_id), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(loginAdminData.createDateTime), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(loginAdminData.updateUser_id), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(loginAdminData.updateDateTime), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_24, [
                    (loginAdminData.status == '0')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_25
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                      : (loginAdminData.status == '1')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_26
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (loginAdminData.status == '2')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _hoisted_27
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    (loginAdminData.rowno == '1')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (loginAdminData.status == '0' || loginAdminData.status == '2')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#loginadminModal",
                                class: "btnLoginAdmin",
                                onClick: ($event: any) => ($setup.confirmModal(loginAdminData.userId_id,'Delete'))
                              }, " Delete ", 8 /* PROPS */, _hoisted_29))
                            : _createCommentVNode("v-if", true),
                          (loginAdminData.status == '1')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#loginadminModal",
                                class: "btnLoginAdmin",
                                onClick: ($event: any) => ($setup.confirmModal(loginAdminData.userId_id,'Activate'))
                              }, " Activate ", 8 /* PROPS */, _hoisted_30))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.isNoData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_31, _hoisted_33))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal For Delete/Activate "),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h4", _hoisted_38, [
              ($setup.confirmModalData[1]=='Delete')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_39
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($setup.confirmModalData[1]=='Activate')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_40
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ]),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              ($setup.confirmModalData[1]=='Delete')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_44
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($setup.confirmModalData[1]=='Activate')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_45
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("button", {
              type: "button",
              id: "modalConfirm",
              class: "btn btn-primary button-design",
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeStatus()))
            }, [
              ($setup.confirmModalData[1]=='Delete')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_48
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($setup.confirmModalData[1]=='Activate')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_49
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}